module.exports = __webpack_public_path__ + "static/media/maveett-logo-login.26d7098b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maveett-logo-login.png
// module id = 754
// module chunks = 0